import $ from 'jquery';
import { kill } from './utilities';
import 'slick-carousel';
/**
 * Attorney profile page - copy section
 *
 * @module profile-copy
 * @version 0.1.0
 * @author hello@bradenericson.com
 *
 * Generated on 2017-09-05 using @14four/generator-excalibur 0.1.23
 * Converted to ES6 on 2023-12-02 using ChatGPT
 */

class ProfileCopy {
  constructor(element) {
    this.$el = $(element);
    this.setDefaults();
    this.setBinds();
    this.setupSlick();

  }

  setDefaults() {
    this.tabs = this.$el.find('.tab-link-container').length > 0;

    if (this.tabs) {
      this.$tab_links = this.$el.find('.tab-link-container a');
      this.$tab_sections = this.$el.find('.tab-section');
      this.$tab_section_title = this.$el.find('.tab-section__title');

      // Initialize all tabs and sections as inactive
      this.$tab_links.removeClass('active');
      this.$tab_sections.removeClass('active');

      // Check for URL fragment
      const urlFragment = window.location.hash;
      let activeTabSet = false;

      if (urlFragment) {
        const $targetTabLink = this.$tab_links.filter(`[href='${urlFragment}']`);
        const $targetTabSection = this.$tab_sections.filter(urlFragment);

        if ($targetTabLink.length && $targetTabSection.length) {
          $targetTabLink.addClass('active');
          $targetTabSection.addClass('active');
          activeTabSet = true;
        }
      }

      // Default to the first tab if no specific tab is set in URL
      if (!activeTabSet) {
        this.$tab_links.first().addClass('active');
        this.$tab_sections.first().addClass('active');
      }
    }
  }



  setBinds() {
    if (this.tabs) {
      //this.$tab_links.on('click', this.tabClick.bind(this));
      this.$el.on('click', '.tab-link-container a', this.tabClick.bind(this));
      this.$tab_section_title.on('click', this.mobileTabClick.bind(this));

    }
  }

  // Set up Slick Slider for Tab Sections
  setupSlick() {
    $(document).ready(function(){
      $('.tab-link-container').slick({
        slidesToShow: 6,
        infinite: false,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 5
            }
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 4
            }
          },
          {
            breakpoint: 800,
            settings: {
              slidesToShow: 3
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1
            }
          }
        ]
      });
    });
  }


  tabClick(evt) {
    kill(evt); // Prevent default action and stop event propagation

    const clicked = $(evt.currentTarget);
    const targetId = clicked.attr('data-tab');

    if (!clicked.hasClass('active')) {
      // Deactivate all tabs and their contents
      this.$tab_links.removeClass('active');
      this.$tab_sections.removeClass('active');

      // Activate the clicked tab and its content
      clicked.addClass('active');
      $(targetId).addClass('active');

      // Update URL fragment
      //history.pushState(null, null, targetId);
    }
  }
  // CLICK
  mobileTabClick(evt) {
    kill(evt);
    let clicked = $(evt.currentTarget);

    if ( clicked.hasClass('active') ) {
      this.$tab_links.removeClass('active');
      this.$tab_sections.removeClass('active');
      this.$tab_section_title.removeClass('active');
    } else {
      this.$tab_links.removeClass('active');
      this.$tab_sections.removeClass('active');
      this.$tab_section_title.removeClass('active');
      $(clicked).parent('.tab-section').addClass('active').children('.tab-section__title').addClass('active');
    }
  }

}

export default ProfileCopy;
